import { UPDATE_SM_INIT, UPDATE_SM_DONE, UPDATE_SM_FAILED } from '../../common/actions';
import { HiverAxios, showMessage, sendTrackingEvent } from 'h-commons';

const SM_ROOT = '/gx/api/sm';

/**
 * Responsible for editing auto responder for the loggedin user
 */
export function changeAutoRespState(smid, autoRespState) {
  let message = "Auto Responder disabled";
  if (autoRespState == "1")
    message = "Auto Responder enabled";
  return (dispatch) => {
    dispatch({ type: UPDATE_SM_INIT });
    HiverAxios({
      url: `${SM_ROOT}/${smid}/autoresponse`,
      type: 'patch',
      params: {
        autoRespState
      },
      callback: (response) => {
        showMessage({ message, type: 'success' });
        if (autoRespState == "1") {
          sendTrackingEvent('enabledAR');
        }
        const respData = response.data.sm;
        dispatch({
          type: UPDATE_SM_DONE,
          payload:respData
        });
      },
      onfail: (response) => {
        dispatch({ type: UPDATE_SM_FAILED });
        showMessage({ message: 'Failed to change auto responder state', type: 'error' });
      }
    });
  };
}
